import React from 'react'
import { Typography } from '@mui/material'
import { PageComponent } from 'types/app'
import { withLayout, withProps } from '@utils/hoc'
import { ArticleLayout } from '@components/common'

import cgv from 'const/cgv.json'

const CGV: PageComponent = () => {
  const { header, articles = [] } = cgv

  return (
    <div className="mx-auto mt-[50px] flex max-w-[730px] flex-col space-y-[50px] px-[10px]">
      <Typography dangerouslySetInnerHTML={{ __html: header }} />
      {articles.map(article => {
        const { content = [], title } = article
        const titleKey = title.replace(/\s/g, '_').substr(0, 10)
        return (
          <div key={titleKey} className="flex flex-col space-y-[20px]">
            <Typography variant="h2" className="text-[25px]">
              {title}
            </Typography>
            {content.map(paragraph => {
              const paragraphKey = paragraph.replace(/\s/g, '_').substr(0, 20)
              return <Typography key={titleKey + '_p_' + paragraphKey} dangerouslySetInnerHTML={{ __html: paragraph }} />
            })}
          </div>
        )
      })}
    </div>
  )
}

const Layout = withProps(ArticleLayout, {
  title: 'Conditions générales de vente'
})

export default withLayout(CGV, Layout)
